import React from 'react';
import './CollectionListingPage.css';
import '@shopify/polaris/dist/styles.css';
import { Page } from '@shopify/polaris';
import CollectionListing from '../components/CollectionListing';
import AuthenticatedPage from '../components/AuthenticatedPage';

function CollectionListingPage() {
  return (
    <AuthenticatedPage>
      {() => <Page><CollectionListing /></Page>}
    </AuthenticatedPage>
  );
}

export default CollectionListingPage;
